module.exports = __webpack_public_path__ + "img/noticia-1.0578049b.jpg";